import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { Navbar, Footer } from "./components/Navbar";
import { ProtectedRoute } from "./components/ProtectedRoute";

// Public Pages
import { LandingPage } from "./pages/LandingPage";
import { RegisterPage } from "./pages/RegisterPage";
import { RegistrationSuccessPage } from "./pages/RegistrationSuccessPage";
import { LoginPage } from "./pages/LoginPage";
import { ActivateAccountPage } from "./pages/ActivateAccountPage";
import { AboutPage } from "./pages/AboutPage";
import { ContactPage } from "./pages/ContactPage";
import { PrivacyPolicyPage } from "./pages/PrivacyPolicyPage";
import { TermsPage } from "./pages/TermsPage";
import { FacultyPage } from "./pages/FacultyPage";
import { ChiefGuestPage } from "./pages/ChiefGuestPage";

// Student Portal Layout & Pages
import { StudentLayout } from "./layouts/StudentLayout";
import { StudentDashboard } from "./pages/student/StudentDashboard";
import { StudentProfile } from "./pages/student/StudentProfile";
import { StudentAttendance } from "./pages/student/StudentAttendance";
import { StudentMaterials } from "./pages/student/StudentMaterials";
import { StudentSchedule } from "./pages/student/StudentSchedule";
import { StudentAnnouncements } from "./pages/student/StudentAnnouncements";

// Admin Portal Layout & Pages
import { AdminLayout } from "./layouts/AdminLayout";
import { AdminDashboard } from "./pages/admin/AdminDashboard";
import { AdminRegistrations } from "./pages/admin/AdminRegistrations";
import { AdminStudents } from "./pages/admin/AdminStudents";
import { AdminAttendance } from "./pages/admin/AdminAttendance";
import { AdminMaterials } from "./pages/admin/AdminMaterials";
import { AdminSchedule } from "./pages/admin/AdminSchedule";
import { AdminAnnouncements } from "./pages/admin/AdminAnnouncements";
import { AdminCertificates } from "./pages/admin/AdminCertificates";
import { StudentCertificate } from "./pages/student/StudentCertificate";
import { CertificateVerificationPage } from "./pages/CertificateVerificationPage";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <div className="min-h-screen bg-background text-foreground flex flex-col font-sans transition-colors">
          <Navbar />
          <div className="flex-1">
            <Routes>
              {/* Public Routes */}
              <Route path="/" element={<LandingPage />} />
              <Route path="/register" element={<RegisterPage />} />
              <Route path="/registration-success" element={<RegistrationSuccessPage />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/activate" element={<ActivateAccountPage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
              <Route path="/terms" element={<TermsPage />} />
              <Route path="/faculty" element={<FacultyPage />} />
              <Route path="/chief-guest" element={<ChiefGuestPage />} />
              <Route path="/verify-certificate/:certificateId" element={<CertificateVerificationPage />} />

              {/* Protected Student Routes */}
              <Route element={<ProtectedRoute allowedRole="student" />}>
                <Route path="/student" element={<StudentLayout />}>
                  <Route index element={<Navigate to="/student/dashboard" replace />} />
                  <Route path="dashboard" element={<StudentDashboard />} />
                  <Route path="profile" element={<StudentProfile />} />
                  <Route path="attendance" element={<StudentAttendance />} />
                  <Route path="materials" element={<StudentMaterials />} />
                  <Route path="schedule" element={<StudentSchedule />} />
                  <Route path="announcements" element={<StudentAnnouncements />} />
                  <Route path="certificate" element={<StudentCertificate />} />
                </Route>
              </Route>

              {/* Protected Admin Routes */}
              <Route element={<ProtectedRoute allowedRole="admin" />}>
                <Route path="/admin" element={<AdminLayout />}>
                  <Route index element={<AdminDashboard />} />
                  <Route path="registrations" element={<AdminRegistrations />} />
                  <Route path="students" element={<AdminStudents />} />
                  <Route path="attendance" element={<AdminAttendance />} />
                  <Route path="materials" element={<AdminMaterials />} />
                  <Route path="schedule" element={<AdminSchedule />} />
                  <Route path="announcements" element={<AdminAnnouncements />} />
                  <Route path="certificates" element={<AdminCertificates />} />
                </Route>
              </Route>

              {/* Catch-all fallback */}
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </div>
          <Footer />
        </div>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
